<script setup lang="ts">
import type { MuseumItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<MuseumItemProps>(), {
  objects: () => [],
  fromname: null,
  frompage: null,
  fromsort: null,
})

const app = useNuxtApp()
const storeIndex = useStoreIndex()

let logoImage = null
let eventLink = null

const linkTo = computed(() => {
  if (props.fromname) {
    // return { name: 'museum-slug', params: { slug: props.item.article_slug }, query: { fromname: props.fromname, frompage: props.frompage, fromsort: props.fromsort } }
    return `/museum/${props.item.article_slug}`
  } else {
    return `/museum/${props.item.article_slug}`
  }
})

if (!eventLink) {
  // 関連記事からイベント取得
  const eventList = app.$getArticleRelationsMulti(props.item, 'event', false)
  eventLink = app.$sortArticleTermFrom(eventList, false)
}

if (props.item.custom?.logo) {
  const imgObj = storeIndex.getImgInfoByID(props.item.custom.logo, props.objects)
  logoImage = imgObj ? imgObj.url : null
  console.log('##MuseumItem logo', logoImage, imgObj)
}
</script>

<template>
  <div class="c-museumItem">
    <div class="c-museumItem_image">
      <nuxt-link
        class="u-hoverZoom"
        v-bind:to="linkTo"
      >
        <CommonImage
          v-bind:src="storeIndex.getArticleEyeCatchImageURL(item.eye_catch_image_object)"
          error-src="/images/noimage.svg"
          v-bind:alt="item.title"
          height="236"
          object-fit="cover"
          is-hover-effect
        />
      </nuxt-link>
    </div>
    <div class="c-museumItem_content">
      <Clip
        class="c-museumItem_content_clip"
        v-bind:article-type-slug="item.article_type_slug"
        v-bind:article-slug="item.article_slug"
        v-bind:count="item.user_favorite_count"
      />
      <div class="c-museumItem_content_row">
        <div class="c-museumItem_content_row_head">
          <nuxt-link
            v-bind:to="linkTo"
          >
            <div class="c-museumItem_content_row_name c-clampLines is-clampline3">
              {{ item.title }}
            </div>
          </nuxt-link>
          <div class="c-museumItem_content_row_prefectures">
            {{ storeIndex.getPrefName(item.custom.prefecture) }}
          </div>
          <div class="c-museumItem_content_row_city">
            {{ item.address_city }}
          </div>
        </div>

        <div
          v-if="logoImage"
        >
          <CommonImage
            class="c-museumItem_content_row_avatar"
            v-bind:src="logoImage"
            object-fit="contain"
          />
        </div>
      </div>
    </div>
    <template v-if="eventLink">
      <div
        v-for="(r, index) in eventLink"
        v-bind:key="r.id"
        class="c-museumItem_detail"
      >
        <template
          v-if="index < 2"
        >
          <v-divider class="c-c-museumItem_detail_divider" />
          <nuxt-link
            v-bind:to="{ path: `/event/${r.article_slug}` }"
          >
            <div class="c-museumItem_detail_event c-clampLines is-clampline2">
              {{ r.title }}
            </div>
          </nuxt-link>
          <div
            class="c-museumItem_detail_duration"
          >
            {{ app.$getPeriodLabel(r.term_from, r.term_to) }}
          </div>
          <PeriodRemain
            v-bind:term-from="r.term_from"
            v-bind:term-to="r.term_to"
            v-bind:hide-day-count="r.day_count_display !== 1"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-museumItem {
  width: 346px;
  margin-top: 35px;
  padding-bottom: 5px;
  border: 1px solid var(--g_color_border_gray);
  font-family: var(--g_font_family_NotoSansCJKjp);
  font-size: 12px;

  @include responsive.mq_down(sp) {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #ebebeb;
    box-shadow: none;
  }

  &_image {
    display: block;
    height: 236px;
  }

  &_content {
    position: relative;
    padding: 20px 20px 12px;
    color: var(--color_text_base);

    &_clip {
      position: absolute;
      top: -18px;
      right: 0;
    }

    &_row {
      display: flex;
      justify-content: space-between;
      margin: 0;
      line-height: 1.556;

      &_head {
        flex-grow: 1;
      }

      &_name {
        margin-top: 4px;
        color: var(--color_text_base);

        // font-size: 18px;
        font-size: 20px;

        // font-weight: bold;
        font-weight: 400;
      }

      &_city {
        margin-top: 4px;
        font-size: 14px;
        font-weight: bold;
      }

      &_prefectures {
        margin-top: 5px;
        color: var(--color_text_base);
        font-size: 14px;
        font-weight: bold;
      }

      &_avatar {
        flex-shrink: 0;
        width: 71px;
        height: 71px;
        margin-top: 9px;
        margin-left: 10px;
        border: 1px solid var(--g_color_grey_main);

        @include responsive.mq_down(sp) {
          width: 61px;
          height: 61px;
        }
      }
    }
  }

  &_detail {
    padding: 8px 20px 0;
    color: var(--color_text_base);

    &_event {
      margin-top: 8px;
      color: var(--color_text_base);
      font-size: 14px;
      font-weight: bolder;
    }

    &_duration {
      margin-top: 5px;
      margin-bottom: 4px;
      font-size: 14px;
    }
  }
}
</style>
